import { Box, IconButton, Stack, Typography } from "@mui/material";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Link } from "react-router-dom";
import { styles } from "../assets/styles";
import logo_b from "../assets/images/logo_b.png";
import { routes } from "../utils/routes";

const FooterTypography = ({ children }) => {
  return (
    <Typography
      variant="caption"
      sx={{
        ...styles.footerQLink,
        ...styles.copyrightText,
        background: "transparent",
      }}
    >
      {children}
    </Typography>
  );
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box sx={{ background: "linear-gradient(135deg, #f8faff 0%, #e8f0ff 35%, #f0e8ff 70%, #f8f5ff 100%)", position: "relative" }}>
      {/* Scroll to Top Button */}
      <IconButton
        onClick={scrollToTop}
        sx={{
          position: "absolute",
          top: { xs: 16, sm: 20 },
          right: { xs: 16, sm: 24 },
          background: "linear-gradient(135deg, #5b7cfa 0%, #764ba2 100%)",
          color: "#fff",
          width: { xs: 44, sm: 50 },
          height: { xs: 44, sm: 50 },
          boxShadow: "0 4px 16px rgba(91, 124, 250, 0.3)",
          transition: "all 0.3s ease",
          "&:hover": {
            background: "linear-gradient(135deg, #764ba2 0%, #5b7cfa 100%)",
            transform: "translateY(-4px)",
            boxShadow: "0 8px 24px rgba(91, 124, 250, 0.4)",
          },
        }}
      >
        <KeyboardArrowUpIcon sx={{ fontSize: { xs: 28, sm: 32 } }} />
      </IconButton>
      <Box
        sx={{
          ...styles.footerCont,
          ...styles.pageLayout,
        }}
      >
        <Stack
          direction={"column"}
          sx={{ height: "100%", maxWidth: "610px", flex: 2 }}
        >
          {/* Footer Logo */}
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              ...styles.footerLogoCol,
            }}
          >
            <Box sx={{ width: { xs: 32, sm: 45 }, height: { xs: 50, sm: 50 } }}>
              <img src={logo_b} alt="Briozon-Logo" />
            </Box>
            <Box component="span" sx={{ color: "#000dc1", fontWeight: 500, ml: 1, fontSize: { xs: 28, sm: 32 } }}>
              Briozon
            </Box>
          </Stack>
          {/* Footer Content*/}
          <Box sx={styles.footerlogotextCont}>
            <Typography variant="subtitle1" align="justify" sx={{ fontSize: { xs: "15px", sm: "16px", md: "17px" } }}>
              Briozon is a next‑generation AI and IT services company, building advanced software, innovative products, and intelligent applications — supported by exceptional talent management capabilities that drive sustainable business success.
            </Typography>
          </Box>
          {/* Links */}
          <Stack
            direction={"column"}
            justifyContent={"flex-start"}
            alignItems={{ xs: "center", sm: "flex-start" }}
            // gap={1}
            sx={{
              width: "100%",
              mx: { xs: 0, sm: 2 },
              mt: { xs: 1, sm: 2 },
              color: "#4b5563",
              textAlign: "center",
            }}
          >
            {/* <Typography
              variant="body2"
              sx={{ ...styles.hoverTopLine, fontWeight: 400, mb: 0.5 }}
            >
              Other Links
            </Typography> */}
            <Stack gap={1} direction={"row"}>
              <Link to={routes.privacyPolicy}>
                <FooterTypography>Privacy Policy</FooterTypography>
              </Link>
              <Link to={routes.cookiePolicy}>
                <FooterTypography>Cookie Policy</FooterTypography>
              </Link>
            </Stack>
          </Stack>
        </Stack>
        {/* Quick Links */}
        <Stack
          direction={"column"}
          alignItems={{ xs: "center", sm: "flex-end" }}
          gap={1}
          sx={{
            flex: 1,
            mx: { xs: 0, sm: 2 },
            // mt: { xs: 1, sm: 2 },
            color: "#4b5563",
            textAlign: { xs: "center", sm: "right" },
          }}
        >
          <Typography
            variant="body2"
            sx={{ ...styles.hoverTopLine, fontWeight: 500, mb: 0.5 }}
          >
            Quick Links
          </Typography>
          <Stack gap={1} direction={"column"}>
            <Link to={routes.services.index}>
              <FooterTypography>Services</FooterTypography>
            </Link>
            <Link to={routes.talentManagement}>
              <FooterTypography>Talent Management</FooterTypography>
            </Link>
            <Link to={routes.products.index}>
              <FooterTypography>Products</FooterTypography>
            </Link>
            <Link to={routes.careers}>
              <FooterTypography>Careers</FooterTypography>
            </Link>
          </Stack>
        </Stack>
        {/* Contact Info */}
        <Stack
          direction={"column"}
          gap={1}
          flex={1}
          alignItems={{ xs: "center", sm: "flex-end" }}
        >
          <Typography
            variant="body2"
            sx={{ ...styles.hoverTopLine, fontWeight: 400, mb: 0.5 }}
          >
            Quick Contact
          </Typography>
          <Stack gap={1} direction={"column"}>
            <IconButton disableRipple sx={{ p: 0, justifyContent: { xs: "center", sm: "flex-end" } }}>
              <EmailRoundedIcon sx={styles.hoverIcon} />
              <Typography variant="subtitle1" sx={{ ml: 1, color: "#4b5563", fontSize: { xs: "15px", sm: "16px", md: "17px" } }}>
                info@briozon.com
              </Typography>
            </IconButton>
            <IconButton disableRipple sx={{ p: 0, justifyContent: { xs: "center", sm: "flex-end" } }}>
              <CallRoundedIcon sx={styles.hoverIcon} />
              <Typography variant="subtitle1" sx={{ ml: 1, color: "#4b5563", fontSize: { xs: "15px", sm: "16px", md: "17px" } }}>
                +1 (469) 844-8747
              </Typography>
            </IconButton>
          </Stack>
          {/* 
          <Button
            disableRipple
            variant="contained"
            sx={{
              backgroundColor: "#fff",
              fontSize: 13,
              fontWeight: "800",
              borderRadius: "25px",
              color: "#000",
              transition: "all 0.1s ease-in",
              ":hover": {
                backgroundColor: "var(--primary-color)",
                color: "#fff",
              },
            }}
          >
            Contact Us
          </Button> */}
        </Stack>
      </Box>

      <Typography sx={styles.copyrightText}>
        Copyright © {currentYear} Briozon - All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
